export const Row = ({hospital}) => {
    return <tr>
        <td><strong>{hospital.name}</strong></td>
        <td>{`${hospital.contact.first_name} ${hospital.contact.last_name}`}</td>
        <td>{`${hospital.contact.email}`}</td>
        <td>{`${hospital.contact.contact_number}`}</td>
    </tr>
}
